export default {
  configPage: {
    notFound: 'Product ID not found',
    tabs: {
      overview: 'General',
      users: 'Users',
      apiTokens: 'API Tokens',
      security: 'Security'
    },
    dangerZone: {
      title: 'Danger Zone',
      description: 'Irreversible actions for this product.',
      deleteTitle: 'Delete product',
      deleteDescription: 'This action is permanent and cannot be undone. All product data will be removed.',
      deleteButton: 'Delete',
      confirmTitle: 'Confirm product deletion',
      confirmDescription: 'This action is irreversible. Type the product name to confirm.',
      confirmLabel: 'Type the product name to confirm:',
      confirmHint: 'Type "{{name}}" to confirm'
    }
  },
  overview: {
    title: 'General',
    description: 'Manage your product information and settings',
    saving: 'Saving...',
    save: 'Save'
  },
  users: {
    title: 'Product Users',
    description: 'Manage which users have access to this product'
  },
  apiTokens: {
    title: 'API Tokens',
    description: 'Manage product-level API tokens for third-party access',
    create: 'Create',
    createTitle: 'Create API Token',
    createDesc: 'Create a new token linked to this product.',
    createSuccessDesc: 'Your API token has been created successfully. You can copy it now or access it later from the token list.',
    tokenName: 'Token name',
    tokenNamePlaceholder: 'e.g. Production Tool',
    setExpiration: 'Set expiration',
    expiresAt: 'Expires at',
    yourToken: 'Your API Token',
    copyToken: 'Copy token',
    copyWarning: '⚠️ Important: Copy this token now! After closing this dialog, only the token prefix will be shown for security reasons. The full token cannot be retrieved later.',
    noTokens: 'No API tokens',
    noTokensDesc: 'Create an API token to allow third-party tools to access scoped endpoints.',
    createFirst: 'Create your first token',
    availableApis: 'Available APIs',
    apisDescription: 'Endpoints accessible with API tokens from this product',
    swaggerLink: 'For full endpoint details, see the Swagger documentation',
    copy: 'Copy',
    copyPrefixBtn: 'Copy Prefix',
    copyFullToken: 'Copy full token',
    copyPrefix: 'Copy token prefix (regenerate to get full token)',
    regenerate: 'Regenerate',
    regenerateTitle: 'Regenerate token - creates a new token and shows it to you',
    active: 'Active',
    inactive: 'Inactive',
    created: 'Created',
    expires: 'Expires',
    usageCount: 'Usage count',
    tokenCopied: 'Token copied to clipboard',
    prefixCopied: 'Token prefix copied to clipboard'
  },
  dialog: {
    usersLoading: "Product users are still loading. Please try again in a moment."
  }
};
